import { NpaIcon, NpaIconSet } from '@stratiods/icons';
import { NpaPositions } from '@stratiods/core';

export type PaginationIconKeys = Exclude<NpaPositions, 'top' | 'bottom'>;
export type PaginationIcon = Exclude<NpaIcon, 'key'> & { key: PaginationIconKeys };
export type PaginationIconSet = Exclude<NpaIconSet, 'icons'> & { icons: Array<PaginationIcon> };

export interface PaginationConfig {
  showItemsPerPage?: boolean;
  showPageNavigatorLabel?: boolean;
  small?: boolean;
  icons?: boolean | PaginationIconSet;
}

export interface Paginate {
  pageFirstItem: number;
  itemsPerPage: number;
}



export const paginationMinimumItemsPerPage: number = 20;
export const paginationMaximumItemsPerPage: number = 500;
